<template>
  <div>
    <section class='input-section'>
      <h4 style="text-transform: uppercase;">Enter your postal/ZIP code to get started!</h4>
      <div v-if="postalError.length > 0" class="info-message error-message">{{ postalError }}</div>

      <input type="text" name="postal_code" class="postal-input" placeholder="LOR 1W0" v-model="postalCode" v-on:keyup.enter="checkPostal">
      <button @click="checkPostal">Enter</button>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postalCode: null,
    };
  },

  computed: {
    postalError() {
      return this.$store.state.postalModal.postalError;
    },
  },

  methods: {

    checkPostal() {
      if (this.postalCode && this.postalCode.length > 0) {
        this.$store.dispatch('setNewPostal', this.postalCode);
      } else {
        this.$store.commit('setProperties', { postalModal: { showModal: false, postalError: 'Please insert a postal/ZIP code.' } });
      }
    },
  },
};
</script>
<style scoped>
  h4 {
    margin-bottom: 0
  }

  .input-section {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(62vh - 1.62em);
    flex-direction: column;
    margin-bottom: 1.62em;
  }

  .postal-input {
    display: flex;
    margin: 1em auto;
    background-color: #F4F4F4;
    font-size: 1.62em;
    border-radius: 0.38em;
    padding: 0.38em;
    border: 1px solid #DBDBDB;
    text-align: center;
  }

  .info-message {
    background-color: #FFF9C4;
    border-left: 3px solid #ffe500;
    padding: 1em;
  }

  .error-message {
    background-color: #FFE6E8;
    color: #cc0015;
    border-left: none;
  }
</style>
